/* unplugin-vue-components disabled */import script from "./NoCredit.vue?vue&type=script&setup=true&lang=js"
export * from "./NoCredit.vue?vue&type=script&setup=true&lang=js"

import "./NoCredit.vue?vue&type=style&index=0&id=6b94eddb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b94eddb"]])

export default __exports__